window.AlpineActionMixin = () => ({
  isLoading: false,
  
  initActions() {
    this.$watch('isLoading', (value) => {
      const element = this.$refs.actionElement || this.$el.querySelector('[x-ref="actionElement"]');
      if (element) {
        element.style.cursor = value ? 'not-allowed' : '';
      }
    });
    
    // Set up automatic event tracking for all element actions
    this.$el.addEventListener('element-action', (event) => {
      const { blockId, settings, triggerType } = event.detail;
      
      // Track if event tracking is enabled (independent of whether there's also an action)
      if (settings.enable_event_tracking) {
        // Use global tracking if available, fallback to custom tracking
        if (window.ArcEventTracking?.trackAction) {
          window.ArcEventTracking.trackAction(event.detail);
        } else {
          // Fallback tracking for backward compatibility
          this.trackEventFallback(event.detail);
        }
      }
    });
  },
  
  /**
   * Fallback event tracking method for when global tracking isn't available
   * @param {object} eventDetail - Element action event detail
   */
  trackEventFallback(eventDetail) {
    const { blockId, settings, triggerType, element } = eventDetail;
    
    // Get block type from element classes
    const blockType = element?.classList?.value?.match(/(\w+)-block/)?.[1] || 'unknown';
    
    // Get action value if available (for inputs, selections, etc.)
    let actionValue = null;
    if (element) {
      const input = element.querySelector('input, select, textarea');
      if (input) {
        actionValue = input.value;
      }
    }

    const eventName = settings.event_name || `${blockType}_${triggerType}`;
    const eventCategory = settings.event_category || 'interaction';
    const eventLabel = settings.event_label || `${blockType} - ${triggerType}`;

    // Debug logging if enabled
    if (window.enableDebugMode) {
      console.log('🔍 Event Tracking Fallback:', {
        eventName,
        eventCategory,
        eventLabel,
        blockType,
        blockId,
        triggerType,
        actionValue,
        settings
      });
    }

    // Track with Google Analytics
    if (typeof window.gtag !== 'undefined') {
      try {
        window.gtag('event', eventName, {
          event_category: eventCategory,
          event_label: eventLabel,
          custom_parameter_1: actionValue,
          block_type: blockType,
          block_id: blockId,
          action_type: triggerType,
          input_name: settings.input_name,
          input_type: settings.input_type,
          action_preset: settings.action_preset
        });
        
        if (window.enableDebugMode) {
          console.log('✅ Google Analytics tracking sent:', eventName);
        }
      } catch (error) {
        console.error('Error tracking with Google Analytics:', error);
      }
    }

    // Track with Google Tag Manager
    if (typeof window.dataLayer !== 'undefined') {
      try {
        window.dataLayer.push({
          event: eventName,
          event_category: eventCategory,
          event_label: eventLabel,
          event_value: settings.event_value || null,
          block_type: blockType,
          block_id: blockId,
          action_type: triggerType,
          action_value: actionValue,
          input_name: settings.input_name,
          input_type: settings.input_type,
          action_preset: settings.action_preset,
          page_url: window.location.href,
          page_title: document.title
        });
        
        if (window.enableDebugMode) {
          console.log('✅ Google Tag Manager tracking sent:', eventName);
        }
      } catch (error) {
        console.error('Error tracking with Google Tag Manager:', error);
      }
    }
  },

  triggerAction(triggerType, blockId, blockSettings) {
    if (window.enableDebugMode) { console.log('Action mixin triggerAction', triggerType, blockId, blockSettings); }
    if (!blockSettings.enable_actions) return;
    
    // Check if this is the correct trigger type
    if (blockSettings.action_trigger && blockSettings.action_trigger !== triggerType) return;
    
    // Prevent duplicate triggers during loading
    if (this.isLoading) return;
    
    const delay = blockSettings.action_delay || 0;
    
    setTimeout(() => {
      // Trigger action event - this handles both functional actions AND pure tracking
      if (window.enableDebugMode) { console.log('######### Dispatching event'); }
      this.$dispatch('element-action', {
        blockId: blockId,
        settings: blockSettings,
        triggerType: triggerType,
        element: this.$el
      });
    }, delay);
  },
  
  handleClick(e, blockId, blockSettings) {
    if (window.enableDebugMode) { console.log('Action mixin handleClick'); }
    if (blockSettings.enable_actions && blockSettings.action_trigger === 'click') {
      e.preventDefault();
    }
    this.triggerAction('click', blockId, blockSettings);
  },
  
  handleHover(e, blockId, blockSettings) {
    if (window.enableDebugMode) { console.log('Action mixin handleHover'); }
    this.triggerAction('hover', blockId, blockSettings);
  },
  
  handleFocus(e, blockId, blockSettings) {
    if (window.enableDebugMode) { console.log('Action mixin handleFocus'); }
    this.triggerAction('focus', blockId, blockSettings);
  }
});